import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { getMemberSubscriptions } from '@vista/omnichannel-components-domain';
import { bemClassBuilder } from '@vista-digital/bem-class-builder';
import { observer } from 'mobx-react';
import { useMemberContext } from '../../../context/member/hooks/use-member-context';
import { useOccConfig } from '../../../context/occ/hooks/use-occ-config';
import { withComponentWrapper } from '../../../utils/with-component-wrapper';
import { MemberSubscriptionNonRecurring } from './subcomponents/non-recurring';
import { MemberSubscriptionRecurring } from './subcomponents/recurring';
import { MemberSubscriptionSkeleton } from './subcomponents/skeleton';
import { defaultMemberSubscriptionProps, memberSubscriptionValidator } from './types/props';
import { isSubscriptionRecurring } from './utils/status-utils';
const b = bemClassBuilder('v-member-subscription');
export const MemberSubscription = observer(props => {
    const { enableSkeletonLoadingIndicators } = useOccConfig();
    const { member } = useMemberContext();
    if (!member) {
        return enableSkeletonLoadingIndicators ? _jsx(MemberSubscriptionSkeleton, {}) : null;
    }
    const memberSubscriptions = getMemberSubscriptions();
    if (!memberSubscriptions)
        return null;
    return (_jsxs("div", Object.assign({ className: b.block() }, { children: [getMemberSubscriptionDetails(props, memberSubscriptions), memberSubscriptions.future && getMemberSubscriptionDetails(props, memberSubscriptions, true)] })));
});
MemberSubscription.displayName = 'MemberSubscription';
const getMemberSubscriptionDetails = (baseProps, memberSubscriptions, isFuture) => {
    // Check if current/future subscription is recurring
    const isRecurring = isFuture && memberSubscriptions.future
        ? isSubscriptionRecurring(memberSubscriptions.future)
        : isSubscriptionRecurring(memberSubscriptions.current);
    const props = Object.assign(Object.assign({}, baseProps), { memberSubscriptions, isFuture });
    return isRecurring ? _jsx(MemberSubscriptionRecurring, Object.assign({}, props)) : _jsx(MemberSubscriptionNonRecurring, Object.assign({}, props));
};
/**
 * The **Member Subscription** component renders the state of a member's subscription.
 */
export const MemberSubscriptionComponent = withComponentWrapper(MemberSubscription, defaultMemberSubscriptionProps, memberSubscriptionValidator);
